import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { AuthorizationObjectType } from '@kheops/graphql';
import { currentContextAtom, globalAuthorizationAtom } from '../../state';
import { useAuthorizationCheckLazyQuery } from '../../queries/__generated__/authorizationCheck.generated';
import { Context } from '../../common/models/user.models';

const GLOBAL_AUTHORIZATION = [
  {
    object: AuthorizationObjectType.Company,
    getObjectId: (context: Context) => context.companyId,
  },
];

interface GlobalAuthorizationResponse {
  isReady: boolean;
}

export function useGlobalAuthorization(): GlobalAuthorizationResponse {
  const context = useAtomValue(currentContextAtom);
  const setGlobalAuthorization = useSetAtom(globalAuthorizationAtom);
  const [isReady, setIsReady] = useState(false);

  const [getAuthorization] = useAuthorizationCheckLazyQuery();

  useEffect(() => {
    const fetchAuthorization = async (): Promise<void> => {
      const authorizations = await Promise.all(GLOBAL_AUTHORIZATION.map(async ({ object, getObjectId }) => {
        const { data } = await getAuthorization({
          variables: {
            object,
            objectId: getObjectId(context),
          },
        });

        return data?.authorizationCheck?.relations.map((relation) => ({
          permission: relation,
          object,
        })) || [];
      }));

      setGlobalAuthorization(authorizations.flat());
      setIsReady(true);
    };

    if (context?.companyId) {
      fetchAuthorization();
    }
  }, [context]);

  return { isReady };
}
